<template>
  <v-card class="h-100">
    <v-chart ref="chart" :options="options" :init="chartInit" @contextmenu="contextmenu" />
  </v-card>
</template>

<script>
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    system: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    values: {
      type: Object,
      required: true,
    },
    formatter: {
      type: Function,
    },
    max: {
      type: Number,
    },
    grid: {
      type: Object,
      default() {
        return {
          top: '25px',
          bottom: '20px',
          left: '5px',
          right: '5px',
        };
      },
    },
    contextmenu: {
      type: Function,
      default: e => e,
    },
  },
  data: () => ({
    options: {},
    systemChanged: true,
    loading: false,
  }),
  computed: {
    echart() {
      return this.$refs.chart.$refs.chart.chart;
    },
    chartInit() {
      return {
        grid: this.grid,
        xAxis: {
          type: 'category',
          data: [''],
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        yAxis: {
          type: 'value',
          max: this.max || 'dataMax',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: params => this.tooltipFormatter(params),
        },
      };
    },
  },
  watch: {
    system: {
      immediate: true,
      handler: 'changSystemHandler',
    },
    items: {
      deep: true,
      handler: 'changItemsHandler',
    },
    values: {
      handler: 'changeValuesHandler',
    },
    isDark: {
      handler: 'changColorHandler',
    },
  },
  methods: {
    changSystemHandler() {
      this.systemChanged = true;
      this.loading = true;
    },
    changItemsHandler() {
      if (!this.systemChanged) this.changColorHandler();
    },
    changeValuesHandler() {
      this.$nextTick(() => {
        if (this.systemChanged) {
          this.options = this.getOptions();
          this.loading = false;
        } else {
          this.options = {
            animation: true,
            series: this.getSeries(),
          };
        }
        this.systemChanged = false;
      });
    },
    changColorHandler() {
      this.options.series.data.forEach((data, index) => {
        this.options.series.data[index].label.color = this.getThemeColor(this.items[index].color, 10, 10);
        this.options.series.data[index].itemStyle.opacity = this.items[index].active ? 0.8 : 0.1;
      });
    },
    getOptions() {
      return {
        xAxis: {
          // BEGIN::Modified.by.KWShin.2023.04.18.
          //data: this.items.map(item => item.id),
          data: this.items.map(item => item.shortAlias),
          // FINISH::Modified.by.KWShin.2023.04.18.
        },
        series: this.getSeries(),
      };
    },
    getSeries() {
      const series = {
        type: 'bar',
        data: this.items.map(item => ({
          value: this.values[item.id],
          label: {
            show: true,
            position: 'top',
            color: this.getThemeColor(item.color, 10, 10),
            formatter: param => this.formatter(param),
          },
          itemStyle: {
            color: item.color,
            opacity: item.active ? 0.8 : 0.1,
          },
        })),
      };
      return series;
    },
    tooltipFormatter(params) {
      const item = this.items.find(item => item.id == params[0].axisValue);
      if (!item) return '';
      this.$emit('update:selectedDescendant', item);
      const label = [this.circle(item.color), `<span style="color:${item.color};font-weight:900;">`, item.id, '</span> : '];
      const list = params.map(param => {
        return this.formatter(param);
      });
      list.unshift(label.join(''));
      return list.join('');
    },
  },
};
</script>
